import {
  formatPecentageValueWithOneDecimal,
  createKpiTileItem,
} from '../../../../utils/helper';
import { KpiHandler, IPCSummaryData } from './types';
import { KpiData } from 'components/redesign/KpiTile/types';

const avgNetThroughputIncrement: KpiHandler = {
  type: 'KpiTile',
  handler: (data: IPCSummaryData): KpiData => {
    const {
      avgNetThroughputIncPercentage,
      avgNetThroughputIncPercentageVsTarget,
    } = data;

    const formattedValue = formatPecentageValueWithOneDecimal(
      avgNetThroughputIncPercentage
    );

    if (avgNetThroughputIncPercentageVsTarget !== null) {
      const tag = {
        text: `${avgNetThroughputIncPercentageVsTarget}`,
        isPositiveValue:
          avgNetThroughputIncPercentageVsTarget.toLowerCase() === 'positive',
        showArrow: false,
      };

      return createKpiTileItem(
        'Average Net Throughput % Increment',
        formattedValue,
        tag
      );
    }

    return createKpiTileItem(
      'Average Net Throughput % Increment',
      formattedValue
    );
  },
};

export default avgNetThroughputIncrement;
